import {
  GB,
  US,
  EU,
  IN,
  JP,
  AU,
  CA,
  CH,
  CN,
  SG,
  NZ,
  MX,
  HK,
  BR,
  RU,
  KR,
  TR,
  ZA,
  SE,
  NO,
  DK,
  PL,
  TH,
  ID,
  MY,
  PH,
  VN,
  AE,
  SA,
  IL,
} from "country-flag-icons/react/3x2";

export const countryFlags: { [key: string]: any } = {
  // Major currencies
  USD: US,
  EUR: EU,
  GBP: GB,
  JPY: JP,
  AUD: AU,
  CAD: CA,
  CHF: CH,
  CNY: CN,
  INR: IN,
  SGD: SG,

  // Additional currencies
  NZD: NZ,
  MXN: MX,
  HKD: HK,
  BRL: BR,
  RUB: RU,
  KRW: KR,
  TRY: TR,
  ZAR: ZA,
  SEK: SE,
  NOK: NO,
  DKK: DK,
  PLN: PL,
  THB: TH,
  IDR: ID,
  MYR: MY,
  PHP: PH,
  VND: VN,
  AED: AE,
  SAR: SA,
  ILS: IL,
};
